import { Card } from "react-bootstrap";
import NoResultsIcon from "resources/images/no-results.jpg";
import Button from "app/storybookComponents/Button";

interface Props {
  message: string;
  subMessage?: string;
  onAction?: () => void; // NEW
  actionLabel?: string; // NEW
}

export default function NotAvailable({
  message,
  subMessage,
  onAction,
  actionLabel,
}: Readonly<Props>) {
  return (
    <Card className="not-available-card text-center p-4">
      <img src={NoResultsIcon} alt="no results" height="80" width="80" />

      <p className="mt-3">{message}</p>
      {subMessage && <p>{subMessage}</p>}

      {/* NEW — show button if provided */}
      {onAction && actionLabel && (
        <Button variant="primary" className="mt-3" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Card>
  );
}
